module.exports = __webpack_public_path__ + "img/job4.7be29303.png";